import { CreatePayrollModel, ShortDirectDebitResponse } from 'src/types';

export type NewPayrollDetails = Pick<CreatePayrollModel, 'name' | 'employerId'> & {
  payrollId: string;
  schemeId: string;
};
export type DirectDebitDetailsFormData = NonNullable<
  Partial<Pick<ShortDirectDebitResponse, 'accountHandlersName' | 'bankAccountNumber' | 'sortCode'>>
> & {
  existingMandateId?: string;
  isConfirmAccountHolder?: boolean;
  isConfirmAuthorisedUser?: boolean;
};
export type DirectDebitDetailsDataFromLS = DirectDebitDetailsFormData & { payrollId: string };

export const NEW_PAYROLL_DETAILS_LS_KEY = 'NEW_PAYROLL_DETAILS';
export const NEW_PAYROLL_DIRECT_DEBIT_DETAILS_LS_KEY = 'NEW_PAYROLL_DIRECT_DEBIT_DETAILS';
export const MULTIPLE_PAYROLLS_FOR_SHARED_DIRECT_DEBIT_DETAILS_LS_KEY =
  'MULTIPLE_PAYROLLS_FOR_SHARED_DIRECT_DEBIT_DETAILS';
export const PAYROLL_NAMES_FOR_SHARED_DIRECT_DEBIT_DETAILS_LS_KEY = 'PAYROLL_NAMES_FOR_SHARED_DIRECT_DEBIT_DETAILS';
